import Rete from 'rete';

import { distSocket } from './index';

import SelectControl from './SelectControl';


import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';

export default class SwitchComponent extends Rete.Component {

	constructor(){
		super("Switch");
		this.path = ["Logic"];
		this.contextMenuName = "Switch";
	}

	builder(node) {
		let inp = new Rete.Input('dist1',"Input", distSocket);
		let out = new Rete.Output('dist', "Output", distSocket);
		let switchvalue = new SelectControl(this.editor, 'switchvalue', false, [
			{ text: 'on', value: 'on' },
			{ text: 'off', value: 'off' },
		]);

		
		return node
			.addInput(inp)
			.addControl(switchvalue)
			.addOutput(out);
	}

	destroyed(node){

		// console.log(`Node ${node.id} was destroyed.`)

		// Remove all event listeners -- otherwise they will respond even if node does no longer exist

	}

	async worker(node, inputs, outputs) {

		// Get all predecessors
		let predecessors = [];

		// Iterate over sockets, and inputs to collect all predecessors (their UUIDs)
		for (let [socket, inputArray] of Object.entries(inputs)) {
			for (let i = 0; i < inputArray.length; i++){
				if (inputArray[i]){
					predecessors.push(inputArray[i]['predecessor']);
				} else {
					console.log('A predecessor could not be determined. Likely because an embedded module is currently open. Any tree view will then be incomplete.')
				}
			}
		}			
		
		// get the current node

		// let nodeSearch = this.editor.nodes.find(n => n.id == node.id);

		// if(nodeSearch) {

		// debugger;

		// let nodeTemp = this.editor.nodes.find(n => n.id == node.id);

		// let switchValueInput = nodeTemp.controls.get('switchvalue').getValue();
		
		let switchvalue = node.data.switchvalue ? node.data.switchvalue : 'on';

		// ============================================================
		let result = [];
		if(inputs['dist1'].length && inputs['dist1'][0].data && switchvalue == 'on' ) {
			result = inputs['dist1'][0].data;
		} else {
			//result = [];
			result = null;
		}
		
		// NEW
		// Generate a new UUID for this node instance(!)
		const nodeUUID = uuidv4();

		outputs['dist'] = {
			predecessor: nodeUUID,
			data: result,
		};

		let hasPredecessors = predecessors.length > 0 ? true : false;

		// Write global node data object
		Vue.prototype.$globalSharedData.globalNodeData[nodeUUID] = {
			hasPredecessors: hasPredecessors,
			predecessors: predecessors,
			nodeID: node.id,
			data: result,
			name: node.data.title,
			nodeFunction: node.name,
			module: undefined,
			nodeData: node.data,
		}


		// ============================================================
		return;
	}
}
